import { darkModeFieldsColor } from '../components/analytics-dashboard/helperConstants';

export const darkModeStyle = {
  backgroundColor: darkModeFieldsColor,
  color: 'white',
  border: 'none',
};
